export default __webpack_public_path__ + "static/media/Snd_q4.4ef439a5.mp3";